/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as SignedInRouteImport } from './routes/signed-in'
import { Route as AuthLinkIdRouteImport } from './routes/auth/$linkId'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as PProjectRouteImport } from './routes/p/$project'
import { Route as PProjectIndexRouteImport } from './routes/p/$project/index'
import { Route as PProjectConnectRouteImport } from './routes/p/$project/connect'
import { Route as PProjectInboxRouteImport } from './routes/p/$project/inbox'
import { Route as PProjectKeysRouteImport } from './routes/p/$project/keys'
import { Route as PProjectLogsRouteImport } from './routes/p/$project/logs'
import { Route as PProjectMailRouteImport } from './routes/p/$project/mail'
import { Route as PProjectPeopleRouteImport } from './routes/p/$project/people'
import { Route as PProjectSettingsRouteImport } from './routes/p/$project/settings'
import { Route as PProjectAccountsIndexRouteImport } from './routes/p/$project/accounts/index'
import { Route as PProjectAccountsAccountIdRouteImport } from './routes/p/$project/accounts/$accountId'
import { Route as PProjectCalendarIndexRouteImport } from './routes/p/$project/calendar/index'
import { Route as PProjectCalendarEventIdRouteImport } from './routes/p/$project/calendar/$eventId'
import { Route as PProjectContactsIndexRouteImport } from './routes/p/$project/contacts/index'
import { Route as PProjectContactsContactIdRouteImport } from './routes/p/$project/contacts/$contactId'
import { Route as PProjectInboxIndexRouteImport } from './routes/p/$project/inbox/index'
import { Route as PProjectInboxChatIdRouteImport } from './routes/p/$project/inbox/$chatId'
import { Route as PProjectMailIndexRouteImport } from './routes/p/$project/mail/index'
import { Route as PProjectMailThreadIdRouteImport } from './routes/p/$project/mail/$threadId'
import { Route as PProjectSettingsIndexRouteImport } from './routes/p/$project/settings/index'
import { Route as PProjectSettingsBillingRouteImport } from './routes/p/$project/settings/billing'
import { Route as PProjectSettingsMembersRouteImport } from './routes/p/$project/settings/members'
import { Route as PProjectWebhooksIndexRouteImport } from './routes/p/$project/webhooks/index'
import { Route as PProjectWebhooksWebhookIdRouteImport } from './routes/p/$project/webhooks/$webhookId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const SignedInRoute = SignedInRouteImport.update({
  id: '/signed-in',
  path: '/signed-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLinkIdRoute = AuthLinkIdRouteImport.update({
  id: '/auth/$linkId',
  path: '/auth/$linkId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/auth/sign-in',
  path: '/auth/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/auth/sign-up',
  path: '/auth/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const PProjectRoute = PProjectRouteImport.update({
  id: '/p/$project',
  path: '/p/$project',
  getParentRoute: () => rootRouteImport,
} as any)
const PProjectIndexRoute = PProjectIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectConnectRoute = PProjectConnectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectInboxRoute = PProjectInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectKeysRoute = PProjectKeysRouteImport.update({
  id: '/keys',
  path: '/keys',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectLogsRoute = PProjectLogsRouteImport.update({
  id: '/logs',
  path: '/logs',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectMailRoute = PProjectMailRouteImport.update({
  id: '/mail',
  path: '/mail',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectPeopleRoute = PProjectPeopleRouteImport.update({
  id: '/people',
  path: '/people',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectSettingsRoute = PProjectSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectAccountsIndexRoute = PProjectAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectAccountsAccountIdRoute =
  PProjectAccountsAccountIdRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => PProjectRoute,
  } as any)
const PProjectCalendarIndexRoute = PProjectCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectCalendarEventIdRoute = PProjectCalendarEventIdRouteImport.update({
  id: '/calendar/$eventId',
  path: '/calendar/$eventId',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectContactsIndexRoute = PProjectContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectContactsContactIdRoute =
  PProjectContactsContactIdRouteImport.update({
    id: '/contacts/$contactId',
    path: '/contacts/$contactId',
    getParentRoute: () => PProjectRoute,
  } as any)
const PProjectInboxIndexRoute = PProjectInboxIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PProjectInboxRoute,
} as any)
const PProjectInboxChatIdRoute = PProjectInboxChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => PProjectInboxRoute,
} as any)
const PProjectMailIndexRoute = PProjectMailIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PProjectMailRoute,
} as any)
const PProjectMailThreadIdRoute = PProjectMailThreadIdRouteImport.update({
  id: '/$threadId',
  path: '/$threadId',
  getParentRoute: () => PProjectMailRoute,
} as any)
const PProjectSettingsIndexRoute = PProjectSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PProjectSettingsRoute,
} as any)
const PProjectSettingsBillingRoute = PProjectSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => PProjectSettingsRoute,
} as any)
const PProjectSettingsMembersRoute = PProjectSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => PProjectSettingsRoute,
} as any)
const PProjectWebhooksIndexRoute = PProjectWebhooksIndexRouteImport.update({
  id: '/webhooks/',
  path: '/webhooks/',
  getParentRoute: () => PProjectRoute,
} as any)
const PProjectWebhooksWebhookIdRoute =
  PProjectWebhooksWebhookIdRouteImport.update({
    id: '/webhooks/$webhookId',
    path: '/webhooks/$webhookId',
    getParentRoute: () => PProjectRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/signed-in': typeof SignedInRoute
  '/auth/$linkId': typeof AuthLinkIdRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/p/$project': typeof PProjectRouteWithChildren
  '/p/$project/connect': typeof PProjectConnectRoute
  '/p/$project/inbox': typeof PProjectInboxRouteWithChildren
  '/p/$project/keys': typeof PProjectKeysRoute
  '/p/$project/logs': typeof PProjectLogsRoute
  '/p/$project/mail': typeof PProjectMailRouteWithChildren
  '/p/$project/people': typeof PProjectPeopleRoute
  '/p/$project/settings': typeof PProjectSettingsRouteWithChildren
  '/p/$project/': typeof PProjectIndexRoute
  '/p/$project/accounts/$accountId': typeof PProjectAccountsAccountIdRoute
  '/p/$project/calendar/$eventId': typeof PProjectCalendarEventIdRoute
  '/p/$project/contacts/$contactId': typeof PProjectContactsContactIdRoute
  '/p/$project/inbox/$chatId': typeof PProjectInboxChatIdRoute
  '/p/$project/mail/$threadId': typeof PProjectMailThreadIdRoute
  '/p/$project/settings/billing': typeof PProjectSettingsBillingRoute
  '/p/$project/settings/members': typeof PProjectSettingsMembersRoute
  '/p/$project/webhooks/$webhookId': typeof PProjectWebhooksWebhookIdRoute
  '/p/$project/accounts/': typeof PProjectAccountsIndexRoute
  '/p/$project/calendar/': typeof PProjectCalendarIndexRoute
  '/p/$project/contacts/': typeof PProjectContactsIndexRoute
  '/p/$project/inbox/': typeof PProjectInboxIndexRoute
  '/p/$project/mail/': typeof PProjectMailIndexRoute
  '/p/$project/settings/': typeof PProjectSettingsIndexRoute
  '/p/$project/webhooks/': typeof PProjectWebhooksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/signed-in': typeof SignedInRoute
  '/auth/$linkId': typeof AuthLinkIdRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/p/$project/connect': typeof PProjectConnectRoute
  '/p/$project/keys': typeof PProjectKeysRoute
  '/p/$project/logs': typeof PProjectLogsRoute
  '/p/$project/people': typeof PProjectPeopleRoute
  '/p/$project': typeof PProjectIndexRoute
  '/p/$project/accounts/$accountId': typeof PProjectAccountsAccountIdRoute
  '/p/$project/calendar/$eventId': typeof PProjectCalendarEventIdRoute
  '/p/$project/contacts/$contactId': typeof PProjectContactsContactIdRoute
  '/p/$project/inbox/$chatId': typeof PProjectInboxChatIdRoute
  '/p/$project/mail/$threadId': typeof PProjectMailThreadIdRoute
  '/p/$project/settings/billing': typeof PProjectSettingsBillingRoute
  '/p/$project/settings/members': typeof PProjectSettingsMembersRoute
  '/p/$project/webhooks/$webhookId': typeof PProjectWebhooksWebhookIdRoute
  '/p/$project/accounts': typeof PProjectAccountsIndexRoute
  '/p/$project/calendar': typeof PProjectCalendarIndexRoute
  '/p/$project/contacts': typeof PProjectContactsIndexRoute
  '/p/$project/inbox': typeof PProjectInboxIndexRoute
  '/p/$project/mail': typeof PProjectMailIndexRoute
  '/p/$project/settings': typeof PProjectSettingsIndexRoute
  '/p/$project/webhooks': typeof PProjectWebhooksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/signed-in': typeof SignedInRoute
  '/auth/$linkId': typeof AuthLinkIdRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/sign-in': typeof AuthSignInRoute
  '/auth/sign-up': typeof AuthSignUpRoute
  '/p/$project': typeof PProjectRouteWithChildren
  '/p/$project/connect': typeof PProjectConnectRoute
  '/p/$project/inbox': typeof PProjectInboxRouteWithChildren
  '/p/$project/keys': typeof PProjectKeysRoute
  '/p/$project/logs': typeof PProjectLogsRoute
  '/p/$project/mail': typeof PProjectMailRouteWithChildren
  '/p/$project/people': typeof PProjectPeopleRoute
  '/p/$project/settings': typeof PProjectSettingsRouteWithChildren
  '/p/$project/': typeof PProjectIndexRoute
  '/p/$project/accounts/$accountId': typeof PProjectAccountsAccountIdRoute
  '/p/$project/calendar/$eventId': typeof PProjectCalendarEventIdRoute
  '/p/$project/contacts/$contactId': typeof PProjectContactsContactIdRoute
  '/p/$project/inbox/$chatId': typeof PProjectInboxChatIdRoute
  '/p/$project/mail/$threadId': typeof PProjectMailThreadIdRoute
  '/p/$project/settings/billing': typeof PProjectSettingsBillingRoute
  '/p/$project/settings/members': typeof PProjectSettingsMembersRoute
  '/p/$project/webhooks/$webhookId': typeof PProjectWebhooksWebhookIdRoute
  '/p/$project/accounts/': typeof PProjectAccountsIndexRoute
  '/p/$project/calendar/': typeof PProjectCalendarIndexRoute
  '/p/$project/contacts/': typeof PProjectContactsIndexRoute
  '/p/$project/inbox/': typeof PProjectInboxIndexRoute
  '/p/$project/mail/': typeof PProjectMailIndexRoute
  '/p/$project/settings/': typeof PProjectSettingsIndexRoute
  '/p/$project/webhooks/': typeof PProjectWebhooksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/signed-in'
    | '/auth/$linkId'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/p/$project'
    | '/p/$project/connect'
    | '/p/$project/inbox'
    | '/p/$project/keys'
    | '/p/$project/logs'
    | '/p/$project/mail'
    | '/p/$project/people'
    | '/p/$project/settings'
    | '/p/$project/'
    | '/p/$project/accounts/$accountId'
    | '/p/$project/calendar/$eventId'
    | '/p/$project/contacts/$contactId'
    | '/p/$project/inbox/$chatId'
    | '/p/$project/mail/$threadId'
    | '/p/$project/settings/billing'
    | '/p/$project/settings/members'
    | '/p/$project/webhooks/$webhookId'
    | '/p/$project/accounts/'
    | '/p/$project/calendar/'
    | '/p/$project/contacts/'
    | '/p/$project/inbox/'
    | '/p/$project/mail/'
    | '/p/$project/settings/'
    | '/p/$project/webhooks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/signed-in'
    | '/auth/$linkId'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/p/$project/connect'
    | '/p/$project/keys'
    | '/p/$project/logs'
    | '/p/$project/people'
    | '/p/$project'
    | '/p/$project/accounts/$accountId'
    | '/p/$project/calendar/$eventId'
    | '/p/$project/contacts/$contactId'
    | '/p/$project/inbox/$chatId'
    | '/p/$project/mail/$threadId'
    | '/p/$project/settings/billing'
    | '/p/$project/settings/members'
    | '/p/$project/webhooks/$webhookId'
    | '/p/$project/accounts'
    | '/p/$project/calendar'
    | '/p/$project/contacts'
    | '/p/$project/inbox'
    | '/p/$project/mail'
    | '/p/$project/settings'
    | '/p/$project/webhooks'
  id:
    | '__root__'
    | '/'
    | '/onboarding'
    | '/signed-in'
    | '/auth/$linkId'
    | '/auth/forgot-password'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/p/$project'
    | '/p/$project/connect'
    | '/p/$project/inbox'
    | '/p/$project/keys'
    | '/p/$project/logs'
    | '/p/$project/mail'
    | '/p/$project/people'
    | '/p/$project/settings'
    | '/p/$project/'
    | '/p/$project/accounts/$accountId'
    | '/p/$project/calendar/$eventId'
    | '/p/$project/contacts/$contactId'
    | '/p/$project/inbox/$chatId'
    | '/p/$project/mail/$threadId'
    | '/p/$project/settings/billing'
    | '/p/$project/settings/members'
    | '/p/$project/webhooks/$webhookId'
    | '/p/$project/accounts/'
    | '/p/$project/calendar/'
    | '/p/$project/contacts/'
    | '/p/$project/inbox/'
    | '/p/$project/mail/'
    | '/p/$project/settings/'
    | '/p/$project/webhooks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OnboardingRoute: typeof OnboardingRoute
  SignedInRoute: typeof SignedInRoute
  AuthLinkIdRoute: typeof AuthLinkIdRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
  PProjectRoute: typeof PProjectRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signed-in': {
      id: '/signed-in'
      path: '/signed-in'
      fullPath: '/signed-in'
      preLoaderRoute: typeof SignedInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/$linkId': {
      id: '/auth/$linkId'
      path: '/auth/$linkId'
      fullPath: '/auth/$linkId'
      preLoaderRoute: typeof AuthLinkIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/auth/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/auth/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$project': {
      id: '/p/$project'
      path: '/p/$project'
      fullPath: '/p/$project'
      preLoaderRoute: typeof PProjectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/p/$project/': {
      id: '/p/$project/'
      path: '/'
      fullPath: '/p/$project/'
      preLoaderRoute: typeof PProjectIndexRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/connect': {
      id: '/p/$project/connect'
      path: '/connect'
      fullPath: '/p/$project/connect'
      preLoaderRoute: typeof PProjectConnectRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/inbox': {
      id: '/p/$project/inbox'
      path: '/inbox'
      fullPath: '/p/$project/inbox'
      preLoaderRoute: typeof PProjectInboxRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/keys': {
      id: '/p/$project/keys'
      path: '/keys'
      fullPath: '/p/$project/keys'
      preLoaderRoute: typeof PProjectKeysRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/logs': {
      id: '/p/$project/logs'
      path: '/logs'
      fullPath: '/p/$project/logs'
      preLoaderRoute: typeof PProjectLogsRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/mail': {
      id: '/p/$project/mail'
      path: '/mail'
      fullPath: '/p/$project/mail'
      preLoaderRoute: typeof PProjectMailRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/people': {
      id: '/p/$project/people'
      path: '/people'
      fullPath: '/p/$project/people'
      preLoaderRoute: typeof PProjectPeopleRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/settings': {
      id: '/p/$project/settings'
      path: '/settings'
      fullPath: '/p/$project/settings'
      preLoaderRoute: typeof PProjectSettingsRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/accounts/': {
      id: '/p/$project/accounts/'
      path: '/accounts'
      fullPath: '/p/$project/accounts/'
      preLoaderRoute: typeof PProjectAccountsIndexRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/accounts/$accountId': {
      id: '/p/$project/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/p/$project/accounts/$accountId'
      preLoaderRoute: typeof PProjectAccountsAccountIdRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/calendar/': {
      id: '/p/$project/calendar/'
      path: '/calendar'
      fullPath: '/p/$project/calendar/'
      preLoaderRoute: typeof PProjectCalendarIndexRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/calendar/$eventId': {
      id: '/p/$project/calendar/$eventId'
      path: '/calendar/$eventId'
      fullPath: '/p/$project/calendar/$eventId'
      preLoaderRoute: typeof PProjectCalendarEventIdRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/contacts/': {
      id: '/p/$project/contacts/'
      path: '/contacts'
      fullPath: '/p/$project/contacts/'
      preLoaderRoute: typeof PProjectContactsIndexRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/contacts/$contactId': {
      id: '/p/$project/contacts/$contactId'
      path: '/contacts/$contactId'
      fullPath: '/p/$project/contacts/$contactId'
      preLoaderRoute: typeof PProjectContactsContactIdRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/inbox/': {
      id: '/p/$project/inbox/'
      path: '/'
      fullPath: '/p/$project/inbox/'
      preLoaderRoute: typeof PProjectInboxIndexRouteImport
      parentRoute: typeof PProjectInboxRoute
    }
    '/p/$project/inbox/$chatId': {
      id: '/p/$project/inbox/$chatId'
      path: '/$chatId'
      fullPath: '/p/$project/inbox/$chatId'
      preLoaderRoute: typeof PProjectInboxChatIdRouteImport
      parentRoute: typeof PProjectInboxRoute
    }
    '/p/$project/mail/': {
      id: '/p/$project/mail/'
      path: '/'
      fullPath: '/p/$project/mail/'
      preLoaderRoute: typeof PProjectMailIndexRouteImport
      parentRoute: typeof PProjectMailRoute
    }
    '/p/$project/mail/$threadId': {
      id: '/p/$project/mail/$threadId'
      path: '/$threadId'
      fullPath: '/p/$project/mail/$threadId'
      preLoaderRoute: typeof PProjectMailThreadIdRouteImport
      parentRoute: typeof PProjectMailRoute
    }
    '/p/$project/settings/': {
      id: '/p/$project/settings/'
      path: '/'
      fullPath: '/p/$project/settings/'
      preLoaderRoute: typeof PProjectSettingsIndexRouteImport
      parentRoute: typeof PProjectSettingsRoute
    }
    '/p/$project/settings/billing': {
      id: '/p/$project/settings/billing'
      path: '/billing'
      fullPath: '/p/$project/settings/billing'
      preLoaderRoute: typeof PProjectSettingsBillingRouteImport
      parentRoute: typeof PProjectSettingsRoute
    }
    '/p/$project/settings/members': {
      id: '/p/$project/settings/members'
      path: '/members'
      fullPath: '/p/$project/settings/members'
      preLoaderRoute: typeof PProjectSettingsMembersRouteImport
      parentRoute: typeof PProjectSettingsRoute
    }
    '/p/$project/webhooks/': {
      id: '/p/$project/webhooks/'
      path: '/webhooks'
      fullPath: '/p/$project/webhooks/'
      preLoaderRoute: typeof PProjectWebhooksIndexRouteImport
      parentRoute: typeof PProjectRoute
    }
    '/p/$project/webhooks/$webhookId': {
      id: '/p/$project/webhooks/$webhookId'
      path: '/webhooks/$webhookId'
      fullPath: '/p/$project/webhooks/$webhookId'
      preLoaderRoute: typeof PProjectWebhooksWebhookIdRouteImport
      parentRoute: typeof PProjectRoute
    }
  }
}

interface PProjectInboxRouteChildren {
  PProjectInboxChatIdRoute: typeof PProjectInboxChatIdRoute
  PProjectInboxIndexRoute: typeof PProjectInboxIndexRoute
}

const PProjectInboxRouteChildren: PProjectInboxRouteChildren = {
  PProjectInboxChatIdRoute: PProjectInboxChatIdRoute,
  PProjectInboxIndexRoute: PProjectInboxIndexRoute,
}

const PProjectInboxRouteWithChildren = PProjectInboxRoute._addFileChildren(
  PProjectInboxRouteChildren,
)

interface PProjectMailRouteChildren {
  PProjectMailThreadIdRoute: typeof PProjectMailThreadIdRoute
  PProjectMailIndexRoute: typeof PProjectMailIndexRoute
}

const PProjectMailRouteChildren: PProjectMailRouteChildren = {
  PProjectMailThreadIdRoute: PProjectMailThreadIdRoute,
  PProjectMailIndexRoute: PProjectMailIndexRoute,
}

const PProjectMailRouteWithChildren = PProjectMailRoute._addFileChildren(
  PProjectMailRouteChildren,
)

interface PProjectSettingsRouteChildren {
  PProjectSettingsBillingRoute: typeof PProjectSettingsBillingRoute
  PProjectSettingsMembersRoute: typeof PProjectSettingsMembersRoute
  PProjectSettingsIndexRoute: typeof PProjectSettingsIndexRoute
}

const PProjectSettingsRouteChildren: PProjectSettingsRouteChildren = {
  PProjectSettingsBillingRoute: PProjectSettingsBillingRoute,
  PProjectSettingsMembersRoute: PProjectSettingsMembersRoute,
  PProjectSettingsIndexRoute: PProjectSettingsIndexRoute,
}

const PProjectSettingsRouteWithChildren =
  PProjectSettingsRoute._addFileChildren(PProjectSettingsRouteChildren)

interface PProjectRouteChildren {
  PProjectConnectRoute: typeof PProjectConnectRoute
  PProjectInboxRoute: typeof PProjectInboxRouteWithChildren
  PProjectKeysRoute: typeof PProjectKeysRoute
  PProjectLogsRoute: typeof PProjectLogsRoute
  PProjectMailRoute: typeof PProjectMailRouteWithChildren
  PProjectPeopleRoute: typeof PProjectPeopleRoute
  PProjectSettingsRoute: typeof PProjectSettingsRouteWithChildren
  PProjectIndexRoute: typeof PProjectIndexRoute
  PProjectAccountsAccountIdRoute: typeof PProjectAccountsAccountIdRoute
  PProjectCalendarEventIdRoute: typeof PProjectCalendarEventIdRoute
  PProjectContactsContactIdRoute: typeof PProjectContactsContactIdRoute
  PProjectWebhooksWebhookIdRoute: typeof PProjectWebhooksWebhookIdRoute
  PProjectAccountsIndexRoute: typeof PProjectAccountsIndexRoute
  PProjectCalendarIndexRoute: typeof PProjectCalendarIndexRoute
  PProjectContactsIndexRoute: typeof PProjectContactsIndexRoute
  PProjectWebhooksIndexRoute: typeof PProjectWebhooksIndexRoute
}

const PProjectRouteChildren: PProjectRouteChildren = {
  PProjectConnectRoute: PProjectConnectRoute,
  PProjectInboxRoute: PProjectInboxRouteWithChildren,
  PProjectKeysRoute: PProjectKeysRoute,
  PProjectLogsRoute: PProjectLogsRoute,
  PProjectMailRoute: PProjectMailRouteWithChildren,
  PProjectPeopleRoute: PProjectPeopleRoute,
  PProjectSettingsRoute: PProjectSettingsRouteWithChildren,
  PProjectIndexRoute: PProjectIndexRoute,
  PProjectAccountsAccountIdRoute: PProjectAccountsAccountIdRoute,
  PProjectCalendarEventIdRoute: PProjectCalendarEventIdRoute,
  PProjectContactsContactIdRoute: PProjectContactsContactIdRoute,
  PProjectWebhooksWebhookIdRoute: PProjectWebhooksWebhookIdRoute,
  PProjectAccountsIndexRoute: PProjectAccountsIndexRoute,
  PProjectCalendarIndexRoute: PProjectCalendarIndexRoute,
  PProjectContactsIndexRoute: PProjectContactsIndexRoute,
  PProjectWebhooksIndexRoute: PProjectWebhooksIndexRoute,
}

const PProjectRouteWithChildren = PProjectRoute._addFileChildren(
  PProjectRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OnboardingRoute: OnboardingRoute,
  SignedInRoute: SignedInRoute,
  AuthLinkIdRoute: AuthLinkIdRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignUpRoute: AuthSignUpRoute,
  PProjectRoute: PProjectRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
